// src\admin\Clients\PublishDataTable.jsx
import React, { useEffect, useState, version } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import swal from "sweetalert";
import { httpAdmin } from "../../Apis/commonApis";
import CareMagnusTable from "../../utils/CareMagnusTable";
import ActivityFormModel from "./activity_notes/ActivityFormModel";
import { FaFilePdf } from "react-icons/fa";
import PreviewButton from "../../components/PreviewButton";
import {
  formatDateToDDMMYYYY,
  getFileOriginalName,
} from "../../utils/CommonFunctions";
import { BsSearch } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { createAccessEvent } from "../../redux-toolkit/reducer/eventLogsReducer";
import { ShowSwal } from "../../utils/alertSwal";
import { styled } from "@mui/material";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";

export const BasicButton = styled("button")(() => ({
  border: "none",
  background: "transparent",
  outline: "none",
  padding: 0,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

function PublishDataTable(props) {
  const { clientId, careteamId } = props;

  const dispatch = useDispatch();

  const [activityData, setActivityData] = useState([]);
  const [isAdd, setIsAdd] = useState(true);
  const [openActivityModal, setActivityModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  // const [searchText, setSearchText] = useState("");

  const handleModalClose = () => {
    setActivityModal(false);
    ActivityTableData(); // Refresh data on modal close
  };

  const ActivityTableData = async () => {
    const res = await httpAdmin(
      clientId
        ? `getProfilePdf?clientId=${clientId}`
        : `getProfilePdf?careTeamId=${careteamId}`,
      "get",
      null,
      null
    );

    setActivityData(
      res?.data?.map((item, index) => {
        return {
          ...item,
          id: item?._id,
          index: index + 1,
          nextReview: item?.nextReview || "-",
          image: item?.pdfLink || "-",
          fileName: item?.pdfLink ? getFileOriginalName(item?.pdfLink) : "",
        };
      }) || []
    );
  };

  useEffect(() => {
    ActivityTableData();
  }, []);

  const handleCreateEvent = (event, rowData) => {
    if (event.target.localName === "img") {
      console.log(rowData, "eeeeeeeeeeeeeeee");
      const logData = {
        documentType: `${clientId ? "Client" : "Careteam"} profile`,
        description: `${
          clientId ? "Client" : "Careteam"
        } profile read successfully`,
        documentId: clientId ?? careteamId,
        version: rowData?.version,
      };
      dispatch(createAccessEvent(logData));
    }
  };

  const columns = [
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 200,
      valueFormatter: (params) => {
        return `${formatDateToDDMMYYYY(params?.value)}`;
      },
    },
    {
      field: "version",
      headerName: "Version No.",
      width: 150,
    },
    {
      field: "image",
      headerName: "",
      width: 50,
      editable: false,
      renderCell: (params) => (
        <BasicButton onClick={(e) => handleCreateEvent(e, params.row)}>
          <PreviewButton filedata={params} />
        </BasicButton>
      ),
    },
    {
      field: "fileName",
      headerName: "pdf Link",
      width: 300,
      editable: false,
    },
  ];

  const handleRowSelection = (selection) => {
    setSelectedRow(selection);
  };

  const handleDelete = async () => {
    if (selectedRow.length === 0) {
      ShowSwal(false, "Please select a row to delete.");
      return;
    }

    const apiEndpoint = clientId
      ? `deleteProfilePdf?clientId=${clientId}`
      : `deleteProfilePdf?careTeamId=${careteamId}`;
    const idsToDelete = {
      ids: selectedRow,
      careHomeId: currentCareSiteId
    };
    const res = await httpAdmin(apiEndpoint, "delete", idsToDelete, null);
    ShowSwal(res.status, res.message ?? "something went wrong");
    if (res.status) {
      ActivityTableData(); // Refresh data after deletion
    }
  };

  return (
    <div>
      <div className="btns_head topButtonShow">
        {/* <div className="searchForm" style={{ width: "50%" }}>
          <input
            type="text"
            className="form-control"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            placeholder="Search"
          />
          <BsSearch className="icon me-2" />
        </div> */}
        <DropdownButton
          id="dropdown-basic-button"
          title="Actions"
          className="d-flex justify-content-end"
        >
          <Dropdown.Item onClick={handleDelete} disabled={!selectedRow}>
            Delete
          </Dropdown.Item>
        </DropdownButton>
      </div>
      <CareMagnusTable
        tableHeight="75vh"
        idParam="id"
        columns={columns}
        rows={activityData}
        selectedRow={selectedRow}
        handleRowSelection={handleRowSelection}
      />
      {openActivityModal && (
        <ActivityFormModel
          openActivityModal={openActivityModal}
          handleModalClose={handleModalClose}
          isAdd={isAdd}
          editKeyContactData={selectedRow}
          clientId={clientId}
          selectedRow={selectedRow}
        />
      )}
    </div>
  );
}

export default PublishDataTable;
